import { withLatestFrom, switchMap, map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import { ApplicationAuthorized, CAAction, Customers } from '../actions';
import { CustomerTeam } from '../actions/index';
import * as selectors from '../reducers/index';
import { CustomersService } from '@careapp-group/ng-sdk';

@Injectable()
export class CustomerTeamEffects {
  fetchCustomerTeam = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerTeam.REQUEST_ALL),
      withLatestFrom(this.store.select(selectors.getSelectedId('customers'))),
      switchMap(([action, id]) =>
        this.customerApi.getTeam({ id }).pipe(
          map((res) => CustomerTeam.ResponseSuccessAllAction(res)),
          catchError((err) => of(CustomerTeam.ResponseFailAllAction(err)))
        )
      )
    )
  );

  fetchCustomerTeamById = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerTeam.RequestAllById),
      switchMap((action) =>
        this.customerApi.getTeam({ id: action.customerId }).pipe(
          map((res) => CustomerTeam.ResponseSuccessAllAction(res)),
          catchError((err) => of(CustomerTeam.ResponseFailAllAction(err)))
        )
      )
    )
  );

  addTeam = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerTeam.REQUEST_CREATE),
      withLatestFrom(this.store.select(selectors.getSelectedId('customers'))),
      switchMap(([action, id]) =>
        this.customerApi
          .addToTeam({
            id,
            memberId: action.payload.staff.id,
            addTeamRequestDto: { role: action.payload.role },
          })
          .pipe(
            map((res) => CustomerTeam.ResponseSuccessAddMemberToCustomer({ permission: res })),
            catchError((err) => of(CustomerTeam.ResponseFailCreateAction(err)))
          )
      )
    )
  );

  addTeamSpecific = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerTeam.RequestCreateForCustomerAction),
      switchMap((action) =>
        this.customerApi
          .addToTeam({
            id: action.customerId,
            memberId: action.memberId,
            addTeamRequestDto: { role: action.role },
          })
          .pipe(
            map((res) => CustomerTeam.ResponseSuccessAddMemberToCustomer({ permission: res })),
            catchError((err) => of(CustomerTeam.ResponseFailCreateAction(err)))
          )
      )
    )
  );

  removeTeam = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerTeam.RequestRemove),
      withLatestFrom(this.store.select(selectors.getSelectedId('customers'))),
      switchMap(([action, id]) =>
        this.customerApi.removeFromTeam({ memberId: action.memberId, id }).pipe(
          map((res) =>
            CustomerTeam.ResponseSuccessRemove({
              memberId: action.memberId,
              customerId: id,
            })
          ),
          catchError((err) => of(CustomerTeam.ResponseFailRemove(err)))
        )
      )
    )
  );

  removeTeamSpecific = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerTeam.RequestRemoveFromCustomerAction),
      switchMap((action) =>
        this.customerApi.removeFromTeam({ memberId: action.memberId, id: action.customerId }).pipe(
          map((res) =>
            CustomerTeam.ResponseSuccessRemove({
              memberId: action.memberId,
              customerId: action.customerId,
            })
          ),
          catchError((err) => of(CustomerTeam.ResponseFailRemove(err)))
        )
      )
    )
  );

  updateCustomerTeamOnModification = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerTeam.ResponseSuccessAddMemberToCustomer),
      map((action) => {
        const customerId = action.permission.modelId;
        return CustomerTeam.RequestAllById({ customerId });
      })
    )
  );

  constructor(
    private store: Store<any>,
    private actions$: Actions<CAAction>,
    private customerApi: CustomersService
  ) {}
}
